import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/Zalo.png'


const _hoisted_1 = { class: "flex flex-col gap-1.5 overflow-auto px-3 py-4" }
const _hoisted_2 = { class: "flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-teal-300/12 text-[15px] !text-teal-200 transition group-hover:bg-teal-300/20 group-hover:!text-teal-100 group-[.router-link-active]:bg-white/18 group-[.router-link-active]:!text-white" }
const _hoisted_3 = { class: "min-w-0 flex-1 truncate leading-5 !text-inherit !no-underline" }
const _hoisted_4 = { class: "mt-auto flex flex-col gap-3 border-t border-white/10 px-3 pb-4 pt-3.5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("aside", {
      class: _normalizeClass(["sticky top-0 flex min-h-screen w-[280px] flex-col bg-[linear-gradient(180deg,#0b1220_0%,#10263a_48%,#0f766e_100%)] text-white shadow-[10px_0_30px_rgba(15,23,42,0.16)] max-md:fixed max-md:bottom-0 max-md:left-0 max-md:z-[1200] max-md:transition-transform", $props.isOpen ? 'max-md:translate-x-0' : 'max-md:-translate-x-full'])
    }, [
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"flex items-center gap-3 border-b border-white/10 px-4 py-4\"><img class=\"h-11 w-11 rounded-xl bg-white object-cover p-0.5 shadow-[0_12px_28px_rgba(0,0,0,0.22)]\" src=\"" + _imports_0 + "\" alt=\"Logo\"><div class=\"min-w-0\"><div class=\"truncate text-[15px] font-black leading-5\"> ZaloOA Phường Hương Trà </div><div class=\"mt-0.5 text-xs font-medium text-slate-300\"> Menu chức năng </div></div></div>", 1)),
      _createElementVNode("nav", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuItems, (item) => {
          return (_openBlock(), _createBlock(_component_RouterLink, {
            key: item.to,
            class: "group relative flex min-h-11 items-center gap-3 rounded-xl px-3 py-2.5 text-[13px] font-semibold !text-slate-100 !no-underline transition duration-150 visited:!text-slate-100 hover:translate-x-0.5 hover:border-teal-300/30 hover:bg-teal-500/12 hover:!text-white hover:!no-underline focus:outline-none [&.router-link-active]:border-teal-300/45 [&.router-link-active]:!bg-teal-600 [&.router-link-active]:!text-white [&.router-link-active]:shadow-[0_10px_22px_rgba(15,118,110,0.24)]",
            to: item.to,
            onClick: $setup.handleNavClick
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, [
                _createElementVNode("span", {
                  class: _normalizeClass(["pi", item.icon])
                }, null, 2)
              ]),
              _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1)
            ]),
            _: 2
          }, 1032, ["to", "onClick"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Button, {
          label: "Đăng xuất",
          onClick: $setup.logout,
          icon: "pi pi-sign-out",
          iconPos: "right",
          class: "w-full !min-h-[42px] border-0 !bg-amber-400 !font-extrabold !text-slate-950 shadow-[0_10px_22px_rgba(245,158,11,0.24)] hover:!bg-amber-300"
        }, null, 8, ["onClick"]),
        _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"border-t border-white/10 pt-2.5 text-center text-[11px] leading-snug text-white/75\"><div class=\"flex flex-wrap items-center justify-center gap-1.5\"><span class=\"pi pi-map-marker text-xs text-white/70\"></span><span>© Copyright 2026 – Phường Hương Trà, Thành phố Đà Nẵng</span></div><div class=\"flex flex-wrap items-center justify-center gap-1.5\"><span class=\"text-xs text-white/45\">·</span><span></span></div></div>", 1))
      ])
    ], 2),
    ($props.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 z-[1100] bg-black/45 md:hidden",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }))
      : _createCommentVNode("", true)
  ]))
}